import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Patient } from 'app/core/models/patient.model';
import { PatientService } from 'app/core/services/patient.service';

import { PatientHeaderComponent } from '../../components/patient-header/patient-header.component';
import { EncounterListComponent } from '../../components/encounter-list/encounter-list.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-patient-encounters',
    templateUrl: './capture-admin-patient-encounters.component.html',
    styleUrls: ['./capture-admin-patient-encounters.component.scss'],
    imports: [PatientHeaderComponent, EncounterListComponent, MatProgressSpinner]
})
export class CaptureAdminPatientEncountersComponent implements OnInit {
  private patientService = inject(PatientService);
  private route = inject(ActivatedRoute);

  patient: Patient;
  loading: boolean;

  ngOnInit() {
    this.init();
  }

  private init() {
    const patientId = parseInt(this.route.snapshot.paramMap.get('id'), 10);
    this.loading = true;
    this.patientService.get(patientId).subscribe(patient => {
      this.patient = patient;
      this.loading = false;
    });
  }

  fetchPatientEncounters = (paging: any, eligible: boolean) => {
    return this.patientService.pagedEncounters(this.patient.id, eligible, paging);
  }
}
